import { render, staticRenderFns } from "./FormExtension.vue?vue&type=template&id=cf2967d4"
import script from "./FormExtension.vue?vue&type=script&lang=js"
export * from "./FormExtension.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports